import { useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import BriefTextField from 'src/components/BriefTextField';
import { CONTEXT_BRIEF_FIELD } from 'src/data/brief';

import { DEFAULT_INPUT_PROPS } from '../../const';

import { useStyles } from './useStyles';

export const FormGeneralContext = ({
  className,
  content,
  onFieldChange,
  onFieldFocus,
  onFieldBlur,
  errors,
  disabled,
}) => {
  const styles = useStyles();

  const valueGeneralContext = content[CONTEXT_BRIEF_FIELD.general] || '';
  const handleGeneralChange = useCallback(
    (value) => {
      onFieldChange(CONTEXT_BRIEF_FIELD.general, value);
    },
    [onFieldChange]
  );

  return (
    <div className={cx(styles.root, className)}>
      <BriefTextField
        className={styles.field}
        rows={3}
        label="Context"
        placeholder="For more accurate generations add context about named entities (Products, Companies, People...) that are mentioned in the 'Content to improve'"
        value={valueGeneralContext}
        onChange={handleGeneralChange}
        error={errors && (errors.general || errors.highlight)}
        disabled={disabled}
        InputProps={{
          ...DEFAULT_INPUT_PROPS,
          onFocus: onFieldFocus,
          onBlur: onFieldBlur,
          rowsMax: 4,
        }}
        classes={{ label: styles.label }}
        isOptional
      />
    </div>
  );
};

FormGeneralContext.propTypes = {
  className: PropTypes.string,
  content: PropTypes.shape().isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFieldFocus: PropTypes.func,
  onFieldBlur: PropTypes.func,
  errors: PropTypes.shape(),
  disabled: PropTypes.bool,
};

FormGeneralContext.defaultProps = {
  className: null,
  onFieldFocus: null,
  onFieldBlur: null,
  errors: null,
  disabled: false,
};
